import { call, put, takeEvery } from 'redux-saga/effects';
import { GET_OEM_PARTNER_REQUEST, SEND_EMAIL_REQUEST } from '../constants/oemConstants';
import { 
  getOemPartnerSuccess, 
  getOemPartnerFailure,
  sendEmailSuccess,
  sendEmailFailure
} from '../actions/oemActions';
import { getOemPartnerApi, sendEmailApi } from '../api/oemApi';
import { toast } from 'react-toastify';

function* getOemPartnerSaga(action) {
  try {
    const response = yield call(getOemPartnerApi, action.payload);
    yield put(getOemPartnerSuccess(response));
  } catch (error) {
    console.error('OEM partner API error:', error);
    yield put(getOemPartnerFailure(error.message));
  }
}

function* sendEmailSaga(action) {
  try {
    const response = yield call(sendEmailApi, action.payload);
    yield put(sendEmailSuccess(response));
    toast.success(response?.message);
  } catch (error) {
    console.error('Send email API error:', error);
    const errorMessage = error.response?.data?.message || error.message || 'Failed to send email';
    yield put(sendEmailFailure(errorMessage));
    toast.error(errorMessage);
  }
}

function* oemSaga() {
  yield takeEvery(GET_OEM_PARTNER_REQUEST, getOemPartnerSaga);
  yield takeEvery(SEND_EMAIL_REQUEST, sendEmailSaga);
}

export default oemSaga;